import { ExcelColumnType } from '../models/api/core/export/export';

export interface ExportColumnDefinition {
  propertyName: string;
  headerText?: string;
  format?: string;
  excelType?: ExcelColumnType;
  stripHtml?: boolean;
}

export function resolveColumnType(
  column: ExportColumnDefinition,
): ExcelColumnType {
  if (column.excelType) {
    return column.excelType;
  }

  if (column.format === 'currency') {
    return 'currency';
  }

  if (column.format === 'number') {
    return 'number';
  }

  return 'text';
}

export function buildColumnTypes(columns: ExportColumnDefinition[]): ExcelColumnType[] {
  return columns.map((column) => resolveColumnType(column));
}

export function hasTypedColumns(columnTypes: ExcelColumnType[]): boolean {
  return columnTypes.some((columnType) => columnType !== 'text');
}

export function coerceExportNumericValue(value: unknown): number | undefined {
  if (typeof value === 'number' && !isNaN(value)) {
    return value;
  }

  const num = parseFloat(String(value).replace(/,/g, '').trim());
  return isNaN(num) ? undefined : num;
}
